module.exports = __webpack_public_path__ + "static/media/high-twoedge-4.0e7abd1e.png";